import { TAG_DELIMITER, useTagBox } from "./TagBox";

interface TagInfo {
  start: number;
  text: string;
}
export const useFindTagAtCaret = () => {
  const { inputRef } = useTagBox();
  return (): TagInfo | undefined => {
    const input = inputRef.current;
    if (!input) return undefined;
    const position = input.selectionStart ?? 0;
    const text = input.value;
    const beforeCaret = text.slice(0, position);
    const delimiterIndex = beforeCaret.lastIndexOf(TAG_DELIMITER);
    if (delimiterIndex === -1) return undefined;

    const textAfterDelimiter = beforeCaret.slice(delimiterIndex + TAG_DELIMITER.length);
    if (/[\s\n]/.test(textAfterDelimiter)) {
      return undefined;
    }
    return {
      start: delimiterIndex,
      text: textAfterDelimiter
    };
  };
};
